'use client';

import { cn } from '@/lib/utils';
import { ElementType, ReactNode, CSSProperties } from 'react';

interface TypographyProps {
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label';
    children: ReactNode;
    className?: string;
    as?: ElementType;
    id?: string;
    style?: CSSProperties;
}

const variantStyles = {
    h1: 'text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-white leading-tight',
    h2: 'text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white leading-tight',
    h3: 'text-lg md:text-xl font-semibold text-gray-900 dark:text-white',
    h4: 'text-lg font-semibold text-gray-900 dark:text-white',
    h5: 'text-base font-semibold text-gray-900 dark:text-white',
    h6: 'text-sm font-semibold text-gray-900 dark:text-white',
    p: 'text-[16px] text-gray-700 dark:text-slate-200 leading-relaxed',
    span: 'text-base text-gray-900 dark:text-white',
    label: 'text-sm font-medium text-gray-700 dark:text-gray-300',
};

const defaultElements = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    span: 'span',
    label: 'label',
};

export function Typography({
    variant = 'p',
    children,
    className,
    as,
    id,
    style,
}: TypographyProps) {
    const Component = as || defaultElements[variant];
    const baseStyles = variantStyles[variant];

    return (
        <Component
            id={id}
            className={cn(baseStyles, className)}
            style={style}
        >
            {children}
        </Component>
    );
}

